import { CookieCategory, localStore } from '@moonpig/web-core-browser-storage'

export type SendCustomerEvent = {
  sendEvent: boolean
  loginMethod?:
    | 'email'
    | 'google'
    | 'apple'
    | 'google one tap'
    | 'password'
    | 'magic link'
}

const tryParse = <T extends Record<string, unknown>>(data: string): T => {
  try {
    return JSON.parse(data)
  } catch (e) {
    return {} as T
  }
}

const localStorageKey = 'mnpg_send_ga_user_data'

export const getSendCustomerEvent = (): SendCustomerEvent => {
  const sendGAUserDataString = localStore.tryGetItem(localStorageKey)
  if (!sendGAUserDataString) {
    return { sendEvent: false }
  }

  const { loginMethod = 'password' } = tryParse<{
    loginMethod: SendCustomerEvent['loginMethod']
  }>(sendGAUserDataString)
  return { sendEvent: true, loginMethod }
}

export const setSendCustomerEvent = (data: { loginMethod: string }) => {
  localStore.trySetItem(
    localStorageKey,
    JSON.stringify(data),
    CookieCategory.STRICTLY_NECESSARY,
  )
}

export const clearSendCustomerEvent = () =>
  localStore.tryRemoveItem(localStorageKey)
